import { shiftParticipantActionMessageTypes } from '../../../../backend/extraTypes';
import { createShiftParticipantHistory } from '../utils/createShiftParticipantHistory';
import { getShiftParticipantStorage } from '../utils/getShiftParticipantStorage';
import { moveRestParticipationsToPending } from '../utils/moveRestParticipationsToPending';
import { getVolunteerApprovalRequests } from './getVolunteerApprovalRequests';
export function approveVolunteersInternal(context, { data, filter, shift, updateProcessedCount, allowDeniedNotQualified, addedByAdmin }) {
    let processedCount = 0;
    const shiftParticipantsStorage = getShiftParticipantStorage(context);
    const approvedParticipants = shiftParticipantsStorage.list({ filter });
    getVolunteerApprovalRequests(data, shift, approvedParticipants).forEach((approvalRequests) => {
        if (!approvalRequests.length) {
            return;
        }
        approvalRequests.forEach((participation) => {
            createShiftParticipantHistory(context, {
                participationId: participation.shiftParticipationId,
                shiftId: shift.id,
                participantId: participation.shiftParticipantId,
                status: 'approved',
            }, { allowDeniedNotQualified });
            moveRestParticipationsToPending(context, shift.id, participation);
            if (addedByAdmin !== undefined) {
                shiftParticipantsStorage.post({
                    action: 'partial-update',
                    id: participation.shiftParticipationId,
                    data: {
                        addedByAdmin,
                    },
                });
            }
            if (updateProcessedCount) {
                updateProcessedCount(++processedCount);
            }
        });
        context.queues.enqueue(shiftParticipantActionMessageTypes.approveParticipant, {
            shiftParticipationIds: approvalRequests.map((approvalReq) => approvalReq.shiftParticipationId),
            shiftParticipantActionSettingName: 'approveParticipants',
        });
    });
}
